var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "question_4_",
    "data-name": "question (4)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_85975",
    "data-name": "Group 85975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85974",
    "data-name": "Group 85974"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242362",
    "data-name": "Path 242362",
    d: "M9,0a9,9,0,1,0,9,9A8.995,8.995,0,0,0,9,0ZM9,16.744A7.744,7.744,0,1,1,16.744,9,7.753,7.753,0,0,1,9,16.744Z",
    fill: "#8e8e8e"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_85980",
    "data-name": "Group 85980",
    transform: "translate(6.554 4.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85977",
    "data-name": "Group 85977",
    transform: "translate(1.279 6.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85976",
    "data-name": "Group 85976"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242363",
    "data-name": "Path 242363",
    d: "M223.715,323.924a.912.912,0,0,0,0,1.824.912.912,0,0,0,0-1.824Z",
    transform: "translate(-222.815 -323.924)",
    fill: "#fd930d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85979",
    "data-name": "Group 85979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85978",
    "data-name": "Group 85978"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242364",
    "data-name": "Path 242364",
    d: "M188.755,127.469c-1.6,0-2.334.948-2.334,1.587a.679.679,0,0,0,.711.675c.64,0,.379-.912,1.587-.912.592,0,1.066.261,1.066.806,0,.64-.663,1.007-1.054,1.339a2.168,2.168,0,0,0-.794,1.8c0,.616.166.794.652.794.58,0,.7-.261.7-.486a1.488,1.488,0,0,1,.663-1.481,3.032,3.032,0,0,0,1.327-2.168C191.278,128.31,190.271,127.469,188.755,127.469Z",
    transform: "translate(-186.421 -127.469)",
    fill: "#fd930d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQue);
export default __webpack_public_path__ + "static/media/que.a7ed856595b69f1fe80d5743b7f06dac.svg";
export { ForwardRef as ReactComponent };